// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/form_response/v1/form_response.proto (package fingertip.creator.form_response.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { CreateFormResponsePublicRequest, CreateFormResponsePublicResponse, DeleteFormResponseRequest, DeleteFormResponseResponse, ExportFormResponsesRequest, ExportFormResponsesResponse, GetCustomerFormResponseRequest, GetCustomerFormResponseResponse, GetCustomerFormResponsesRequest, GetCustomerFormResponsesResponse, GetFormResponseRequest, GetFormResponseResponse, GetFormResponsesRequest, GetFormResponsesResponse, GetSiteContactFormResponsesRequest, GetSiteContactFormResponsesResponse } from "./form_response_pb.js";

/**
 * @generated from rpc fingertip.creator.form_response.v1.FormResponseService.GetFormResponses
 */
export const getFormResponses = {
  localName: "getFormResponses",
  name: "GetFormResponses",
  kind: MethodKind.Unary,
  I: GetFormResponsesRequest,
  O: GetFormResponsesResponse,
  service: {
    typeName: "fingertip.creator.form_response.v1.FormResponseService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_response.v1.FormResponseService.GetFormResponse
 */
export const getFormResponse = {
  localName: "getFormResponse",
  name: "GetFormResponse",
  kind: MethodKind.Unary,
  I: GetFormResponseRequest,
  O: GetFormResponseResponse,
  service: {
    typeName: "fingertip.creator.form_response.v1.FormResponseService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_response.v1.FormResponseService.CreateFormResponsePublic
 */
export const createFormResponsePublic = {
  localName: "createFormResponsePublic",
  name: "CreateFormResponsePublic",
  kind: MethodKind.Unary,
  I: CreateFormResponsePublicRequest,
  O: CreateFormResponsePublicResponse,
  service: {
    typeName: "fingertip.creator.form_response.v1.FormResponseService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_response.v1.FormResponseService.DeleteFormResponse
 */
export const deleteFormResponse = {
  localName: "deleteFormResponse",
  name: "DeleteFormResponse",
  kind: MethodKind.Unary,
  I: DeleteFormResponseRequest,
  O: DeleteFormResponseResponse,
  service: {
    typeName: "fingertip.creator.form_response.v1.FormResponseService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_response.v1.FormResponseService.GetSiteContactFormResponses
 */
export const getSiteContactFormResponses = {
  localName: "getSiteContactFormResponses",
  name: "GetSiteContactFormResponses",
  kind: MethodKind.Unary,
  I: GetSiteContactFormResponsesRequest,
  O: GetSiteContactFormResponsesResponse,
  service: {
    typeName: "fingertip.creator.form_response.v1.FormResponseService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_response.v1.FormResponseService.GetCustomerFormResponses
 */
export const getCustomerFormResponses = {
  localName: "getCustomerFormResponses",
  name: "GetCustomerFormResponses",
  kind: MethodKind.Unary,
  I: GetCustomerFormResponsesRequest,
  O: GetCustomerFormResponsesResponse,
  service: {
    typeName: "fingertip.creator.form_response.v1.FormResponseService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_response.v1.FormResponseService.GetCustomerFormResponse
 */
export const getCustomerFormResponse = {
  localName: "getCustomerFormResponse",
  name: "GetCustomerFormResponse",
  kind: MethodKind.Unary,
  I: GetCustomerFormResponseRequest,
  O: GetCustomerFormResponseResponse,
  service: {
    typeName: "fingertip.creator.form_response.v1.FormResponseService"
  }
};

/**
 * @generated from rpc fingertip.creator.form_response.v1.FormResponseService.ExportFormResponses
 */
export const exportFormResponses = {
  localName: "exportFormResponses",
  name: "ExportFormResponses",
  kind: MethodKind.Unary,
  I: ExportFormResponsesRequest,
  O: ExportFormResponsesResponse,
  service: {
    typeName: "fingertip.creator.form_response.v1.FormResponseService"
  }
};
